/* eslint-disable no-console */
const FIREBASE_INDEXED_DB = "firebaseLocalStorageDb";

export const clearIndexedDbAfterLogOut = (): void => {
  if (indexedDB) {
    const response = indexedDB.deleteDatabase(FIREBASE_INDEXED_DB);

    response.onsuccess = (): void => {
      console.log(`Deleted database ${FIREBASE_INDEXED_DB} successfully`);
    };

    response.onerror = (): void => {
      console.log(`Couldnt delete database ${FIREBASE_INDEXED_DB}`);
    };

    response.onblocked = (): void => {
      console.log(
        `Couldn't delete database ${FIREBASE_INDEXED_DB} due to the operation being blocked`
      );
    };
  } else {
    console.log("IndexedDB is not supported by current browser");
  }
};
